var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.417,29.586c-0.912-0.623-2.157-0.387-2.779,0.525L18.204,46.873c-0.463,0.68-0.463,1.574,0,2.254l11.435,16.762 c0.387,0.567,1.015,0.873,1.654,0.873c0.388,0,0.78-0.112,1.125-0.348c0.913-0.623,1.147-1.867,0.525-2.779L22.277,48 l10.666-15.635C33.565,31.453,33.33,30.208,32.417,29.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.796,46.873L66.361,30.111c-0.623-0.912-1.866-1.147-2.779-0.525c-0.913,0.623-1.147,1.867-0.525,2.779L73.723,48 L63.057,63.635c-0.622,0.912-0.388,2.156,0.525,2.779c0.345,0.235,0.737,0.348,1.125,0.348c0.639,0,1.267-0.306,1.654-0.873 l11.435-16.762C78.26,48.447,78.26,47.553,77.796,46.873z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.676,29.355c-1.041-0.374-2.186,0.169-2.557,1.208L40.115,64.088c-0.373,1.039,0.168,2.185,1.208,2.557 c0.223,0.08,0.451,0.118,0.674,0.118c0.821,0,1.59-0.51,1.883-1.327l12.004-33.523C56.257,30.873,55.716,29.728,54.676,29.355z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding);
export default __webpack_public_path__ + "static/media/coding.9054dc24dae4fa8a4d7816aac983328d.svg";
export { ForwardRef as ReactComponent };